// extracted by mini-css-extract-plugin
export default {"wrap":"_q-z","melodyCategory":"ar-z","fullWidth":"br-z","items":"cr-z","featureCss":"dr-z","disabled":"er-z","imgCss":"fr-z"};